import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { AnserMark } from "@/components/ui/anser-mark";

/**
 * The sidebar brand block from the platform sketch: the Anser mark with its
 * glow beside "Graftus" (20/800) and the tagline "med Anser" (11/600,
 * primary). On the collapsed icon rail only the mark remains. Tokens only.
 */
export function BrandBlock() {
  const { t } = useTranslation("nav");
  return (
    <Link
      to="/"
      aria-label="Graftus"
      className="flex items-center gap-3 rounded-g-md px-1 py-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-g-ring group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0"
      data-testid="brand-block"
    >
      <AnserMark size={46} glow />
      <span className="flex flex-col leading-none group-data-[collapsible=icon]:hidden">
        <span className="text-[20px] font-extrabold tracking-[-0.02em] text-g-ink-900">
          Graftus
        </span>
        <span className="mt-[3px] text-[11px] font-semibold tracking-[0.02em] text-g-primary">
          {t("brand.tagline")}
        </span>
      </span>
    </Link>
  );
}
